import React, {useEffect} from 'react'
import { API } from '../../Backend'
import logo from '../../utility/images/logo.png'
import axios from 'axios'
import { useState } from 'react'
import Toaster from '../../components/util/Toaster'
import { useNavigate } from 'react-router-dom'
import VerifyPayment from './VerifyPayment'

const Razorpay = ({number, email, name, amount, orderId}) => {

    const [toaster, setToaster] = useState(false);
    const [message, setMessage] = useState("")
    const [verifyPayment, setVerifyPayment] = useState(false)
    const [dataForVerification, setDataForVerification] = useState({})
    const navigate = useNavigate()

    console.log(number)

    const config = {
      headers: {
          "Content-type": 'application/json',
          Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      withCredentials: true
    }

    useEffect(() => {
        showRazorpay()
    }, [])

    const loadScript = (src) => {
        return new Promise((resolve) => {
            const script = document.createElement('script')
            script.src = src
            script.onload = () => {
              resolve(true)
            }
            script.onerror = () => {
              resolve(false)
            }
            document.body.appendChild(script)
          })
    }

    const showRazorpay = async () => {

            const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js')
        
            if (!res) {
              alert('Razorpay SDK failed to load. Are you online?')
              return
            }
                  
            const {data} = await axios.post(`${API}/payments/createorder`,{amount} , config)
        
            const options = {
              key: 'rzp_test_cE0jjwQXyQjoWw',
              currency: data.currency,
              amount: data.amount.toString(),
              order_id: data.order_id,
              name: 'Donation',
              description: 'Thank you for nothing. Please give us some money',
              image: logo,
              handler: function (response) {
                console.log(response);
                let values ={
                    razorpay_order_id : response.razorpay_order_id,
                    razorpay_payment_id : response.razorpay_payment_id,
                    razorpay_signature : response.razorpay_signature,
                    amount : amount,
                    order_id : orderId
                }
                setDataForVerification(values)
                setVerifyPayment(true)
              },
              prefill: {
                name: name,
                email: email,
                contact: number
              }
            }
            const paymentObject = new window.Razorpay(options)
            paymentObject.open()
    }

    const handleToaster = (message) => {
        setToaster(true)
        setMessage(message)
        setTimeout(() => {
          setToaster(false)
          setMessage("")
        }, 5000);
      }

  return (
    <div>
        {toaster && message && <Toaster text={message} timeout={5} icon={"X"} />}
        {verifyPayment && <VerifyPayment verifyDetails={dataForVerification}/>}
    </div>
    
  )
}

export default Razorpay